import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SideDrawerComponent } from '../side-drawer/side-drawer.component';
import { ButtonComponent } from '../../atoms/button/button.component';
import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
  selector: 'app-translations-drawer',
  standalone: true,
  imports: [CommonModule, FormsModule, SideDrawerComponent, ButtonComponent, IconComponent],
  templateUrl: './translations-drawer.component.html',
  styleUrls: ['./translations-drawer.component.scss'],
})
export class TranslationsDrawerComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() width = 'w-[1000px]';
  @Input() languages: Array<any> = [];
  @Input() value: any = null; // expected shape: { label: {}, placeholder: {}, help_text: {}, validation_message: {} }

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onSave(): void {
    // Emit save (mutations are applied directly to `value` via ngModel bindings)
    this.save.emit();
  }

  trackByCode(index: number, lang: any) {
    return lang?.code || index;
  }
}
